"use strict";

var isValue = require("../is-value");

var keys = Object.keys;

module.exports = function (object) {
	return keys(isValue(object) ? Object(object) : object);
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/keys/shim.js
// module id = 733
// module chunks = 0